import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'log-out',
  templateUrl: './logout.component.html',
  standalone: false
})
export class LogOutComponent implements OnDestroy {
  ngOnDestroy(): void {
    // Clean up resources if needed
    // No additional cleanup required for this simple logout
  }
}
